<template>
    <div style="">
        <div class="box1" style="text-align: center">
            <div style="overflow: hidden; margin: 30px auto">
                <div v-for="(item, index) in list_data" :key="index">
                    <div class="box4" :style="{ marginTop: index == 0 ? '0px' : '50px' }">
                        {{ item.title }}
                    </div>
                    <div :class="['box3', menu_index == i.id ? 'xuanzhong_sty' : '']" @click="changMenu(i)" v-for="(i, a) in item.list" :key="a">
                        {{ i.txt }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'App',
    props: ['active'],
    data() {
        return {
            menu_index: 0,
            list_data: [
                {
                    title: '账号管理',
                    list: [
                        { txt: '个人中心', id: 0, link: '/user' },
                        { txt: '账户安全', id: 2, link: '/account_security' },
                        { txt: '收货地址', id: 3, link: '/address_list' },
                        { txt: '我的积分', id: 4, link: '/integral' },
                        { txt: '我的收藏', id: 5, link: '/collection' },
                        { txt: '我的足迹', id: 6, link: '/footprint' },
                        { txt: '消息通知', id: 7, link: '/message' },
                        { txt: '反馈列表', id: 19, link: '/my_feedback' }
                    ]
                },
                {
                    title: '主体管理',
                    list: [
                        { txt: '个人信息', id: 1, link: '/user_info' },
                        { txt: '企业信息', id: 8, link: '/enterprise_info' },
                        { txt: '我的资质', id: 9, link: '/qualifications' },
                        { txt: '授信建档', id: 10, link: '/credit_y' }
                    ]
                },
                {
                    title: '交易管理',
                    list: [
                        { txt: '我的订单', id: 11, link: '/order' },
                        // { txt: '定制订单', id: 12, link: '/dinzhi_order' },
                        { txt: '发票管理', id: 13, link: '/control_over_invoices' },
                        { txt: '开票记录', id: 20, link: '/billing_record' }
                    ]
                },
                {
                    title: '服务中心',
                    list: [
                        { txt: '关于科隆', id: 14, link: '/about_us' },
                        { txt: '服务与支持', id: 15, link: '/service_support' },
                        { txt: '订购指南', id: 16, link: '/ordering_guide' },
                        { txt: '参考资料', id: 17, link: '/reference_material' },
                        { txt: '退换货流程说明', id: 18, link: '/return_policy' }
                    ]
                }
            ]
        };
    },
    methods: {
        changMenu(e) {
            if (this.$route.path === e.link) {
                window.location.reload();
            } else {
                this.$router.push(e.link);
            }
        }
    },
    created() {
        this.list_data.forEach(e => {
            e.list.forEach(_e => {
                if (this.$route.path == '/invoice_details') {
                    this.menu_index = 20;
                }
                if (this.$route.path == '/add_ticket_collection_method') {
                    this.menu_index = 13;
                }
                if (this.$route.path == '/complaint_details') {
                    this.menu_index = 19;
                }
                if (this.$route.path == '/complaint_details') {
                    this.menu_index = 19;
                }
                if (this.$route.path == '/add_pupiao') {
                    this.menu_index = 13;
                }
                if (this.$route.path == '/add_zhuanpiao') {
                    this.menu_index = 13;
                }
                if (_e.link == this.$route.path) {
                    this.menu_index = _e.id;
                }
                if (this.$route.path == '/add_feedback') {
                    this.menu_index = 19;
                }
                if (this.$route.path == '/change_tel') {
                    this.menu_index = 2;
                }
                if (this.$route.path == '/user_info_edit') {
                    this.menu_index = 1;
                }
                if (this.$route.path == '/chang_login_password') {
                    this.menu_index = 2;
                }
                if (this.$route.path == '/refund_details') {
                    this.menu_index = 7;
                }
                if (this.$route.path == '/refund') {
                    this.menu_index = 11;
                }
            });
        });
    }
};
</script>

<style scoped>
.xuanzhong_sty {
    border-left: 2px solid #2b9a34;
    color: #2b9a34 !important;
}
.box3 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: Regular;
    color: #666666;
    margin-top: 6%;
    cursor: pointer;
    box-sizing: border-box;
    text-align: left;
    padding-left: 70px;
}

.box4 {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
    text-align: left;
    padding-left: 70px;
}

.box1 {
    width: 220px;
    /* height: 972px; */
    border: 1px solid #ede9e9;
    float: left;
    margin-top: 2%;
}

.box2 {
    width: 100%;
    height: 45px;
    background: #f2f2f2;
}
</style>



// WEBPACK FOOTER //
// src/public/user_left.vue